/* eslint-disable react-hooks/exhaustive-deps */
import { node } from 'prop-types'
import React, { createContext, useEffect, useState } from 'react'
import { useAuthProvider } from 'shared/application/hooks/useAuthProvider.hook'

const FeatureFlagContext = createContext()

const FeatureFlagsProvider = ({ children }) => {
  const flags = useFlags()

  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

function useFlags() {
  const auth = useAuthProvider()
  const currentEnvironment = process.env.NODE_ENV
  const [flags, setFlags] = useState()

  const enableFeature = (envs = [], authorizedSources = []) => {
    return (
      envs.includes(currentEnvironment) &&
      authorizedSources.includes(auth.user.affiliateNameAlias)
    )
  }

  const enableFeatureForAllBut = (envs = [], unauthorizedSources = []) => {
    return (
      auth.user.affiliateNameAlias &&
      envs.includes(currentEnvironment) &&
      !unauthorizedSources.includes(auth.user.affiliateNameAlias)
    )
  }

  const initializeFlags = () => ({
    dashboardFlow: enableFeature(
      ['staging', 'development', 'production'],
      [
        'TT001',
        'TT007',
        'CNPJ2',
        'AF128', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'AF223', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'AF231', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'AF336', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'AF418', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'AF699', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'CN688', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'CN888', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'MF005', // parceiro do programa Creditas Partners turma 1 (iniciativa de dashboard de Autônomos)
        'CB337', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'CB398', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'MF013', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ773', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ753', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ772', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ826', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ815', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'AF309', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ814', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ805', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
        'GQ816', // parceiro do programa Creditas Partners turma 2 (iniciativa de dashboard de Autônomos)
      ],
    ),
    heroBannerCampaignFlow: enableFeatureForAllBut(
      ['staging', 'development', 'production'],
      [
        'TT001',
        'TT007',
        'CNPJ2',
        'CF302',
        'CF827',
        'CF505',
        'CF827',
        'CF543',
        'CF505',
        'CB306',
        'RE388',
        'CI406',
        'CI407',
        'CI455',
        'CI456',
        'CI464',
      ],
    ),
  })

  useEffect(() => {
    if (auth.user) {
      const flagsList = initializeFlags()
      setFlags(flagsList)
    }
  }, [currentEnvironment, auth.user])

  return {
    ...flags,
  }
}

function useFeatureFlag() {
  const context = React.useContext(FeatureFlagContext)
  if (context === undefined) {
    throw new Error('useFeatureFlag must be used within a FeatureFlagContext')
  }
  return context
}

FeatureFlagsProvider.propTypes = {
  children: node.isRequired,
}

export { useFeatureFlag, FeatureFlagsProvider, useFlags }
